/*
 * Mask Controller
 * Formats phone numbers as (xxx) xxx-xxxx for US numbers only
 *
 * Usage with intl-tel-input:
 * <div data-controller="mask">
 *   <input type="tel"
 *          id="phone"
 *          name="phone"
 *          data-action="input->mask#phone"
 *          placeholder="(555) 123-4567">
 * </div>
 *
 * The controller checks for intl-tel-input's country selector button.
 * If no selector is present or if United States is selected,
 * the phone number will be formatted as (xxx) xxx-xxxx
 */

import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {}

  phone(event) {
    // Find the intl-tel-input wrapper (v25+ uses .iti__selected-country button)
    const itiWrapper = event.target.closest('.iti')
    const selectedCountry = itiWrapper?.querySelector('.iti__selected-country')
    const value = event.target.value.trim()
    // A typed or pasted non-US "+<dial code>" is kept so intl-tel-input can switch the flag
    const international = selectedCountry != null && /^\+(?!1)/.test(value)

    // Only format if no country selector is present or if US is selected
    if (!international && (selectedCountry == null || selectedCountry.title === 'United States')) {
      let digits = event.target.value.replace(/\D/g, '')
      // Browser autofill and pasted numbers often arrive as +1XXXXXXXXXX.
      // US area codes never start with 1, so a leading 1 on an 11+ digit
      // number is the country code — drop it before formatting.
      if (digits.length > 10 && digits.startsWith('1')) {
        digits = digits.slice(1)
      }
      const x = digits.match(/(\d{0,3})(\d{0,3})(\d{0,4})/)
      event.target.value = !x[2]
        ? x[1]
        : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '')
    } else {
      // Non-US country: keep a leading + and digits only; phone_controller
      // adds the dial code on submit when there is no +
      event.target.value = value.replace(/(?!^\+)\D/g, '')
    }
  }
}
